import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/developer/messaging-schedule")({
    beforeLoad: () => {
        throw redirect({ to: "/design/features/messaging-schedule", replace: true });
    },
});
